<app-auth-page-layout>
  <div class="flex flex-col flex-1">

    <div class="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
      <div class="mb-5 sm:mb-8 text-center">
        <h1 class="mb-2 font-semibold text-gray-800 text-title-sm dark:text-white/90 sm:text-title-md">
          Change Password Required
        </h1>
        <p class="text-sm text-gray-600 dark:text-gray-400">
          Enter your current password and choose a new one.
        </p>
      </div>

      <form (ngSubmit)="submit()" class="space-y-6">
        <div>
          <app-label>Current Password <span class="text-error-500">*</span></app-label>
          <app-input-field type="password" placeholder="Enter your current password" [value]="currentPassword"
            (valueChange)="currentPassword = $event.toString()" name="currentPassword" class="form-input" required
            [disabled]="isSubmitting" />
        </div>

        <div>
          <app-label>New Password <span class="text-error-500">*</span></app-label>
          <app-input-field type="password" placeholder="Enter new password" [value]="newPassword"
            (valueChange)="newPassword = $event.toString()" name="newPassword" class="form-input" required
            [disabled]="isSubmitting" />
        </div>

        <div>
          <app-label>Confirm Password <span class="text-error-500">*</span></app-label>
          <app-input-field type="password" placeholder="Confirm new password" [value]="confirmPassword"
            (valueChange)="confirmPassword = $event.toString()" name="confirmPassword" class="form-input" required
            [disabled]="isSubmitting" />
        </div>

        <app-button className="w-full" size="sm" (btnClick)="submit()" [disabled]="!canSubmit">
          @if (isSubmitting) {
          <span class="flex items-center gap-2">
            <span class="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></span>
            Updating password...
          </span>
          } @else {
          Change Password
          }
        </app-button>

        <button type="button" (click)="cancelToLogin()"
          class="w-full text-sm text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
          [disabled]="isSubmitting">
          Back to Login
        </button>
      </form>
    </div>
  </div>
</app-auth-page-layout>
